import API from "../../../API/API";

const api = new API();
const endPoints = "verify_otp";

export const postOtpVerificationApi = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      // Use skipErrorHandling to prevent global error handler from redirecting on 401
      const result = await api.post(endPoints, data, { skipErrorHandling: true });
      resolve(result);

    } catch (error) {
      console.error("API error", error);
      reject(error);
    }
  })
}